<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- ngx-datatable-filter -->
              <fieldset class="form-group">
                <div class="row align-items-end mt-0 pagination-body">
  
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 ">
                    <div class="btn-group enrollment-list-btn-info" role="group">
                      <button class="btn enrollment-list-buttons" type="button" *ngFor="let status of task_status_list"
                        [ngClass]="{'btn-primary':activeTab==status?.name,'btn-outline-primary':activeTab!=status?.name}"
                        (click)="activeEmployeeTab(status?.name)">{{status.displayname}}</button>
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                    <div class="row-flex">
                      <div class="col-flex-2">
                        <span class="cursor-pointer" (click)="openViewModal(viewModal)">View </span> |
                         <span class="cursor-pointer" (click)="gotoEdit()">Edit</span>
                      </div>
                      <div class="col-flex-2">
                        <ng-select [items]="project_list" bindLabel="name" bindValue="_id" placeholder="Select Project"
                        [(ngModel)]="selected_project_id" [ngModelOptions]="{ standalone: true }"
                        (change)="getCheckTypeId($event)" (search)="onSearch($event)" class="project-select">
                      </ng-select>
                      </div>
  
                      <div class="col-flex-2">
                        <button class="btn btn-outline-primary" placement="top" ngbTooltip="Add New"
                          (click)="openModalAddCheckList(addCheckListModal)">+</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 pagination-body header-body mb-2">
                    <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                      [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                      [count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)">
                      <ngx-datatable-footer>
                        <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize">
                          <div class="datatable-footer-inner">
                            <div class="total-count">
                              <span>Total : {{page.totalPages}}</span>
                            </div>
                          </div>
                        </ng-template>
                      </ngx-datatable-footer>
  
                    </ngx-datatable>
                  </div>
                </div>
                <div class="row align-items-end mt-0 pagination-body mb-2">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12  ">
                    <div class="row-flex filter-tabs">
                      <div class="col-flex-2 filter">
                        <ng-select [items]="empList" bindLabel="name" bindValue="_id" placeholder="Select User"
                          [(ngModel)]="selected_user_id" [ngModelOptions]="{ standalone: true }"
                          (change)="getUserId($event)">
                        </ng-select>
                      </div>
                      <div class="col-flex-2 filter">
                        <ng-select [items]="task_priority_List" bindLabel="displayname" bindValue="_id"
                          placeholder="Select User" [(ngModel)]="selected_priority_id"
                          [ngModelOptions]="{ standalone: true }" (change)="getPriorityId($event)">
                        </ng-select>
                      </div>
                      <div class="col-flex-2 filter">
                        <ng-select [items]="scheduleList" bindLabel="name" bindValue="id" placeholder="Select Schedule"
                          [(ngModel)]="selectedSchedule_filter" [ngModelOptions]="{ standalone: true }" (change)="getChangeScheduleId($event)">
                        </ng-select>
                      </div>
                      <div class="col-flex-2 filter">
                        <ng-select [items]="task_stage_list" bindLabel="displayname" bindValue="_id"
                          placeholder="Select User" [(ngModel)]="selected_stage_id"
                          [ngModelOptions]="{ standalone: true }" (change)="getStageId($event)">
                        </ng-select>
                      </div>
                      <div class="col-flex-2">
                        <button class="btn btn-outline-primary" (click)="resetFilter()">Reset Filter</button>
                      </div>
                      <div class="col-flex-2">
                        <button data-toggle="collapse" data-target="#demo" class="btn btn-outline-primary" (click)="toggleCollapse()" [attr.aria-expanded]="isCollapsed ? 'false' : 'true'">{{ isCollapsed ? 'Collapse' : 'Expand' }}</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mt-1">
                    <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Project Sprint Guideline</button>
                  </div>
                </div>
              </fieldset>
              <div>
              <div *ngFor="let list of rows;let i=index">
                <div class="main_heading cursor-pointer"  (click)="collapse.toggle()" [attr.aria-expanded]="taskView[i]"
                  aria-controls="collapseExample">
                  <h5 [ngClass]="{'bg-light-info badge ': list?.label?.displayname =='Assignment',
                    'bg-light-warning badge': list?.label?.displayname =='Events',
                    'bg-light-danger badge ': list?.label?.displayname =='Leave',
                      'bg-light-primary badge': list?.label?.displayname =='Demo'}">
                      {{list?._id}} ({{list?.total}})</h5>
                </div>
                
                  <ngx-datatable id="demo" #collapse="ngbCollapse" [(ngbCollapse)]="taskView[i]" class="bootstrap core-bootstrap collapse"
                    [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
                    [limit]="limitRef" [rows]="list?.tasks" [scrollbarH]="true" [columns]="columns">
                    <ngx-datatable-column name="Title" prop="title" [width]="100">
                      <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                        <div class="d-flex align-items-center">
                          <div class="cell-line-height">
                            <p [ngClass]="{'bg-light-info badge ': list?.label?.displayname =='Assignment'}"
                              *ngIf="list?.label?.displayname =='Assignment'">{{list?.label?.displayname}}</p>
                            <p [ngClass]="{'bg-light-warning badge': list?.label?.displayname =='Events'}"
                              *ngIf=" list?.label?.displayname =='Events'">{{list?.label?.displayname}}</p>
                            <p [ngClass]="{'bg-light-danger badge ': list?.label?.displayname =='Leave'}"
                              *ngIf="list?.label?.displayname =='Leave'">{{list?.label?.displayname}}</p>
                            <p [ngClass]="{'bg-light-primary badge': list?.label?.displayname =='Demo'}"
                              *ngIf="list?.label?.displayname =='Demo'">{{list?.label?.displayname}}</p>
  
                            <p class="font-medium-1 line-height-1 mb-2 cursor-pointer"
                              (click)="openModalUpdate(adminNotesModal,row?._id,row?.admin_notes,'admin_notes')">{{row?.title}}</p>
                            <div class="users-box ">
                              <div class="text-muted font-small-2 " *ngFor="let user of row?.to">
                                <span class="bg-light-primary badge badge-pill cursor-pointer"
                                  (click)="openModalEmp(myModal,row?.to,row?._id)"> {{user?.name}}</span>
                              </div>
                            </div>
                            <div class="users-box ">
                              <div [matMenuTriggerFor]="task_priority" class="text-muted font-small-2"
                                >
                                <span *ngIf="row?.priority[0]?.displayname =='Normal'" class="bg-light-info badge badge-pill cursor-pointer">
                                  {{row?.priority[0]?.displayname}}</span>
                                <span *ngIf="row?.priority[0]?.displayname =='Medium'" class="bg-light-warning badge badge-pill cursor-pointer">
                                  {{row?.priority[0]?.displayname}}</span>
                                <span *ngIf="row?.priority[0]?.displayname =='High'" class="bg-light-danger badge badge-pill cursor-pointer">
                                  {{row?.priority[0]?.displayname}}</span>
                                <span *ngIf="row?.priority[0]?.displayname =='Urgent'" class="bg-light-danger badge badge-pill cursor-pointer">
                                  {{row?.priority[0]?.displayname}}</span>
                              </div>
                             
                              <mat-menu #task_priority="matMenu">
  
                                <div>
                                  <div *ngFor="let priority of task_priority_List">
                                    <button mat-menu-item *ngIf="priority?.displayname !== row?.priority[0]?.displayname"
                                      (click)="updatePrority(row?._id,priority._id)">
                                      <span>
                                        <span
                                          [ngClass]="{'bg-light-info badge badge-pill':priority.displayname == 'Normal'}"
                                          placement="top"
                                          *ngIf="priority.displayname == 'Normal'">{{priority.displayname}}</span>
                                        <span
                                          [ngClass]="{'bg-light-warning badge badge-pill':priority.displayname == 'Medium'}"
                                          placement="top"
                                          *ngIf="priority.displayname == 'Medium'">{{priority.displayname}}</span>
                                        <span
                                          [ngClass]="{'bg-light-danger badge badge-pill':priority.displayname == 'High'}"
                                          placement="top"
                                          *ngIf="priority.displayname == 'High'">{{priority.displayname}}</span>
                                        <span
                                          [ngClass]="{'bg-light-danger badge badge-pill':priority.displayname == 'Urgent'}"
                                          placement="top"
                                          *ngIf="priority.displayname == 'Urgent'">{{priority.displayname}}</span>
                                      </span>
                                    </button>
                                  </div>
                                 
                                </div>
                              </mat-menu>
  
                            </div>
                            <div class="users-box">
                              <p class="schedule-box badge badge-pill">{{row?.is_schedule}}</p>
                            </div>
                          </div>
  
                        </div>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Body" prop="body" [width]="150">
                      <ng-template let-rowIndex="rowIndex" let-row="row" let-name="value" ngx-datatable-cell-template>
                        <div>
                          <div class="d-flex">
                            <span class="current-task-box" *ngIf="row?.body" [innerHtml]="row?.body"></span>
                            <span *ngIf="!row?.body || row?.body =='\n'">
                              <i class="ft-plus text-primary cursor-pointer"
                                (click)="openModalUpdate(myModal3,row?._id,row?.body,'body')" placement="right"
                                ngbTooltip="add new"></i>
                            </span>
                            <span class="ml-2"  *ngIf="row?.body" > <i  (click)="openModalUpdate(myModal3,row?._id,row?.body,'body')"
                                class="ft-edit text-primary cursor-pointer"></i> </span>
                          </div>
                        
                        </div>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Notes" prop="notes" [width]="150">
                      <ng-template let-rowIndex="rowIndex" let-row="row" let-name="value" ngx-datatable-cell-template>
                        <div>
                          <div class="d-flex">
                            <span class="current-task-box" *ngIf="row?.notes" [innerHtml]="row?.notes"></span>
                            <span *ngIf="!row?.notes || row?.notes =='\n'">
                              <i class="ft-plus text-primary cursor-pointer"
                                (click)="openModalUpdate(myModal3,row?._id,row?.notes,'notes')" placement="right"
                                ngbTooltip="add new"></i>
                            </span>
                            <span class="ml-2" *ngIf="row?.notes"> <i  (click)="openModalUpdate(myModal3,row?._id,row?.notes,'notes')"
                                class="ft-edit text-primary cursor-pointer"></i> </span>
                          </div>
                          
                        </div>
  
                      </ng-template>
                    </ngx-datatable-column>
  
                    <ngx-datatable-column name="Actions" [width]="10">
  
                      <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                        <div class="mb-1" [ngClass]="{'bg-light-danger': row?.due_date < today_date , 'bg-light-success': row?.due_date > today_date }">{{row?.due_date | date:'mediumDate'}}</div>
                        <div>
                          <i mat-button [matMenuTriggerFor]="menu" class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
                          <i mat-button [matMenuTriggerFor]="menu2" class="ft-settings text-primary cursor-pointer mr-2"></i>
                          <i class="ft-copy my-1 primary cursor-pointer" (click)="copyItem(row?._id)"></i>
                        
                        </div>
                        <div class="users-box">
                          <p  mat-button [matMenuTriggerFor]="stageMenu">
                            
                            <span [ngClass]="{'badge badge-pill bg-light-success':row?.stage[0]?.displayname =='Completed'}" *ngIf="row?.stage[0]?.displayname =='Completed'">{{row?.stage[0]?.displayname}}</span>
                            <span [ngClass]="{'badge badge-pill bg-light-danger':row?.stage[0]?.displayname =='Backlog'}" *ngIf="row?.stage[0]?.displayname =='Backlog'">{{row?.stage[0]?.displayname}}</span>
                            <span [ngClass]="{'badge badge-pill bg-light-warning':row?.stage[0]?.displayname =='In-Review'}" *ngIf="row?.stage[0]?.displayname =='In-Review'">{{row?.stage[0]?.displayname}}</span>
                            <span [ngClass]="{'badge badge-pill bg-light-primary':row?.stage[0]?.displayname =='Current'}" *ngIf="row?.stage[0]?.displayname =='Current'">{{row?.stage[0]?.displayname}}</span>
  
                          </p>
                        </div>
  
                        <mat-menu #stageMenu="matMenu">
                          <div *ngFor="let stage of stage_list">
                            <button class="btn mb-1" style="width: 100%;" [ngClass]="{'bg-light-success':stage.displayname =='Completed','bg-light-danger':stage.displayname =='Backlog',
                            'bg-light-warning':stage.displayname =='In-Review','bg-light-primary':stage.displayname =='Current'}" *ngIf="stage.displayname !=row?.stage[0]?.displayname"
                            (click)="updateStage(row?._id,stage?._id)" >{{stage.displayname}}</button >
                          </div>
                        </mat-menu>
  
                        <mat-menu #menu="matMenu">
                          <div>
                            <button (click)="taskEdit(addCheckListModal,row?._id)" class="btn mb-1"
                              style="width: 100%;">Edit</button>
                            <button class="btn bg-light-danger" style="width: 100%;" (click)="ConfirmDelete(row._id,rowIndex)">Delete</button>
                          </div>
                          
                          
                        </mat-menu>
                        <mat-menu #menu2="matMenu">
                        <div *ngFor="let status of task_status_list">
                          <button class="btn" style="width: 100%;" (click)="updateStatus(row?._id,status?._id)" *ngIf="activeTab != status?.name">{{status?.displayname}}</button>
                        </div>
                        </mat-menu>
                      </ng-template>
                    </ngx-datatable-column>
  
                    <!-- <ngx-datatable-column name="Actions" [width]="40"
                          *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                          <ng-template let-row="row" ngx-datatable-cell-template>
                            <i class="ft-plus text-primary cursor-pointer" placement="right"
                            ngbTooltip="add badge" (click)="openModal(myModal,row?._id)"></i> -->
                    <!-- <i class="ft-edit text-primary cursor-pointer mr-2"
                              [routerLink]="['/employees/edit',row?.user?._id]"></i>
                            <i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger"
                              (click)="Delete(row._id)"></i>
                            <i class="ft-copy text-primary cursor-pointer ml-2 mr-2" placement="top"
                              ngbTooltip="Copy Default Password" (click)="copyToClipboard(row?.user?.name,row?.user?.phone)"></i>
                            <i *ngIf="user_role.roles =='admin'" class="icon-key text-primary cursor-pointer" placement="top"
                              ngbTooltip="set default password" (click)="setDefaultPassword(row?.user?._id, row?.user?.name)"></i> -->
                    <!-- </ng-template>
                        </ngx-datatable-column> -->
                  </ngx-datatable>
              </div>
              </div>

              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--/ Filter Datatables -->
  <div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
  </div>
  
  <!--------- -->
  
  <div>
    <ng-template #myModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title">Ownership Update</h4>
        <button type="button" class="close" (click)="modal.dismiss()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <ng-select [items]="empList" bindLabel="name" bindValue="_id" placeholder="Select Employee"
          [(ngModel)]="selectedEmp" [multiple]="true" [ngModelOptions]="{ standalone: true }" (change)="getEmpId($event)"
          [appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true">
        </ng-select>
  
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="updateAssignTo()">Submit</button>
      </div>
    </ng-template>
  </div>
  
  <!-------- Add New Checklist Popup ----------------------->
  
  
  <div>
    <ng-template #addCheckListModal let-modal>
      <div class="modal-header">
        <h3 *ngIf="!task_id">Create Task</h3>
        <h3 *ngIf="task_id">Update Task</h3>
  
        <button type="button" class="close" (click)="modal.dismiss()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="modal-body taskboard-modal">
          <form [formGroup]="myForm">
            <div class="container">
  
              <fieldset class="form-group position-relative has-icon-left">
                <ng-select [items]="empList" bindLabel="name" bindValue="_id" placeholder="Select Employee"
                  [(ngModel)]="selectedEmp" [multiple]="true" [closeOnSelect]="false"
                  [ngModelOptions]="{ standalone: true }" (open)="onDropdownOpenEmp($event)"
                  (close)="onDropdownCloseEmp($event)">
                  <ng-template ng-header-tmp>
                    <div class="checkbox-container">
                      <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}"
                        (click)="toggleAllSelectionEmp()">
                      <span>Select All</span>
                    </div>
                  </ng-template>
  
                  <ng-template ng-option-tmp let-item="item">
                    <div class="checkbox-container">
                      <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"
                        (change)="toggleSelectionEmp(item)">
                      <span>{{ item.name }}</span>
                    </div>
                  </ng-template>
                </ng-select>
              </fieldset>
              <fieldset class="form-group position-relative has-icon-left">
                <ng-select *ngIf="task_model ==''" [items]="project_list" bindLabel="name" bindValue="_id"
                  placeholder="Select project" [(ngModel)]="selected_project_id"
                  [ngModelOptions]="{ standalone: true }" (change)="getCheckListId($event)" (search)="onSearch($event)">
                </ng-select>
                <ng-select *ngIf="task_model !=''" [items]="project_list" bindLabel="name" bindValue="_id"
                  placeholder="Select project" [(ngModel)]="selected_project_id" [ngModelOptions]="{ standalone: true }"
                  (change)="getCheckListId($event)" (search)="onSearch($event)">
                </ng-select>
              </fieldset>
              <!-- <fieldset class="form-group position-relative has-icon-left">
                <ng-select [items]="taskLabelList" bindLabel="displayname" bindValue="_id" placeholder="Select TaskLabel"
                  [(ngModel)]="selected_task_label" [ngModelOptions]="{ standalone: true }"
                  (change)="getChangeTaskLabelId($event)">
                </ng-select>
  
              </fieldset> -->
              <fieldset class="form-group position-relative has-icon-left">
                <div class="form-control-position">
                  <i class="ft-edit-2"></i>
                </div>
                <input type="text" formControlName="title" [(ngModel)]="task_model.title" class="form-control"
                  id="todoTitle" placeholder="Title" (keydown.enter)="$event.preventDefault()" required #todoTitle>
                <div class="form-control-position control-position-right">
                  <i class="ft-edit-2"></i>
                </div>
              </fieldset>
              <fieldset class="form-group position-relative has-icon-left">
                <!-- <div class="form-control-position">
                  <i class="ft-message-square"></i>
                </div> -->
                <label>Body</label>
                <quill-editor (onContentChanged)="inlineAddupdateBody(task_model.body,'body')"
                  [(ngModel)]="task_model.body" [ngModelOptions]="{standalone: true}" [modules]="{toolbar: false}">
                </quill-editor>
                <!-- <textarea formControlName="body" [(ngModel)]="task_model.body" class="form-control" placeholder="body">
                
              </textarea> -->
              </fieldset>
              <fieldset>
                <ng-select [items]="scheduleList" bindLabel="name" bindValue="id" placeholder="Select Schedule"
                  [(ngModel)]="selectedSchedule" [ngModelOptions]="{ standalone: true }"
                  (change)="getScheduleId($event)">
                </ng-select>
              </fieldset>
  
              <fieldset class="form-group position-relative has-icon-left mt-2">
                <div class="form-control-position">
                  <i class="fa-regular fa-calendar-days"></i>
                </div>
                <input *ngIf="!task_id" type="date" formControlName="due_date" [(ngModel)]="current_date"
                  class="form-control">
                  <input *ngIf="task_id" type="date" formControlName="due_date" [(ngModel)]="task_model.due_date" class="form-control">
                <div class="form-control-position control-position-right">
                  <i class="fa-regular fa-calendar-days"></i>
                </div>
              </fieldset>
              <fieldset class="form-group position-relative has-icon-left mt-2">
                <div class="form-control-position">
                  <i class="ft-clock"></i>
                </div>
                <input *ngIf="!task_model.working_hours" type="text" formControlName="time" [(ngModel)]="time"
                  class="form-control">
                <input *ngIf="task_model.working_hours" type="text" formControlName="time"
                  [(ngModel)]="task_model.working_hours" class="form-control">
  
                <div class="form-control-position control-position-right">
                  <i class="ft-clock"></i>
                </div>
              </fieldset>
              <fieldset class="form-group position-relative has-icon-left mt-2">
                <div class="form-control-position">
                  <i class="ft-dollar-sign"></i>
                </div>
                <input *ngIf="!task_model.budget" type="text" formControlName="budget" [(ngModel)]="budget_val"
                  class="form-control" placeholder="Enter budget">
                <input *ngIf="task_model.budget" type="text" formControlName="budget" [(ngModel)]="task_model.budget"
                  class="form-control" placeholder="Enter budget">
                <div class="form-control-position control-position-right">
                  <i class="ft-dollar-sign"></i>
                </div>
              </fieldset>
              <fieldset class="form-group position-relative has-icon-left">
                <!-- <div class="form-control-position">
                  <i class="ft-message-square"></i>
                </div>
                <textarea formControlName="notes" [(ngModel)]="task_model.notes" class="form-control" placeholder="notes">
                <div class="form-control-position control-position-right">
                  <i class="ft-message-square"></i>
                </div>
              </textarea> -->
              <label>Notes</label>
              <quill-editor (onContentChanged)="inlineAddupdateBody(task_model.notes,'notes')" [(ngModel)]="task_model.notes"
                [ngModelOptions]="{standalone: true}" [modules]="{toolbar: false}">
              
              </quill-editor>
              </fieldset>
              <fieldset class="form-group position-relative has-icon-left">
                <!-- <div class="form-control-position">
                  <i class="ft-message-square"></i>
                </div>
                <textarea formControlName="admin_notes" [(ngModel)]="task_model.admin_notes" class="form-control"
                  placeholder="guidelines">
                <div class="form-control-position control-position-right">
                  <i class="ft-message-square"></i>
                </div>
              </textarea> -->
              <label>Guidelines</label>
              <quill-editor (onContentChanged)="inlineAddupdateBody(task_model.admin_notes,'admin_notes')" [(ngModel)]="task_model.admin_notes"
                [ngModelOptions]="{standalone: true}" [modules]="{toolbar: false}">
              
              </quill-editor>
              </fieldset>
            </div>
          </form>
  
        </div>
      </div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button> -->
        <button *ngIf="!task_id " type="button" class="btn btn-primary" (click)="createTask()">Create</button>
        <button *ngIf="task_id " type="button" class="btn btn-primary" (click)="submit()">Update</button>
      </div>
    </ng-template>
  </div>
  
  <!----- Admin Notes / Guideline Update Popup -->
  
  <div class=" modal-Admin-Notes">
    <ng-template #adminNotesModal let-modal>
      <div class=" modal-Admin-Notes">
      <div class="modal-header">
        <h4 class="modal-title">Guidelines</h4>
        <button type="button" class="close" (click)="modal.dismiss()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
       
        <div>
          <div class="d-flex" >
            <span class="current-task-box" *ngIf="!isEditor && update_row_data" [innerHtml]="update_row_data"></span>
            <span *ngIf="!update_row_data  ">
              <i (click)="isEditor =!isEditor" class="ft-plus text-primary cursor-pointer" 
                placement="right" ngbTooltip="add new"></i>
            </span>
            <span class="ml-2" *ngIf="update_row_data"> <i (click)="isEditor =!isEditor" class="ft-edit text-primary cursor-pointer"></i> </span>
          </div>
          <div *ngIf="isEditor">
            <quill-editor (onEditorCreated)="setFocus($event)" (onContentChanged)="inlineEditing(update_row_data)"
              [(ngModel)]="update_row_data"></quill-editor>
          </div>
        
        </div>
  
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="submitEditData()">Submit</button>
      </div>
      </div>
    </ng-template>
  </div>
  
  <!-------- Update Task Body Or Notes -->
  
  <div>
    <ng-template #myModal3 let-modal>
      <div class="modal-header">
        <h4 class="modal-title" *ngIf="isReadOnly">Add</h4>
        <h4 class="modal-title" *ngIf="!isReadOnly">Update</h4>
  
        <button type="button" class="close" (click)="modal.dismiss()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="text-editor">
        <quill-editor (onEditorCreated)="setFocus($event)" (onContentChanged)="inlineEditing(update_row_data)"
          [(ngModel)]="update_row_data"></quill-editor>
        </div>
       
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="submitEditData()">Submit</button>
      </div>
    </ng-template>
  </div>
  
   <!-- ============ -->

<div class=" modal-Admin-Notes">
  <ng-template #viewModal let-modal>
    <div class=" modal-Admin-Notes">
    <div class="modal-header">
      <h4 class="modal-title">{{jobData?.name |titlecase}}'s View</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
     
      
      <!-- Media object ends -->
    
      <div class="row">
     
        <div class="col-12">
          <!-- User detail starts -->
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <div class="row bg-primary bg-lighten-4 rounded mb-3 mx-1
                  text-center text-md-left">
                  <div class="col p-3 d-flex align-itms-center firstdiv">
                    <h6 class="primary align-self-center mb-0 mx-1">Registered:</h6>
                    <span class="font primary">{{jobData?.created_at | date :'shortDate'}}</span>
                    <span *ngIf="!jobData?.created_at" class="font primary">Data Not Found</span>
                  </div>
                  <div class="col p-3 d-flex align-itms-center firstdiv">
                    <h6 class="primary align-self-center mb-0 mx-1">Latest Activity:</h6>
                    <span class="font primary">{{jobData?.updated_at | date :'shortDate'}}</span>
                    <span class="font primary" *ngIf="!jobData?.updated_at">Data Not Found</span>
                  </div>
                  <!-- <div class="col p-3 d-flex align-itms-center firstdiv">
                    <h6 class="primary align-self-center mb-0 mx-1">Role:</h6>
                    <span class="font primary">{{jobData?.user_id?.roles}}</span>
                    <span class="font primary" *ngIf="!jobData?.user_id?.roles">Data Not Found</span>
                  </div> -->
                  <div class="col p-3 d-flex align-itms-center firstdiv">
                    <h6 class="primary align-self-center mb-0 mx-1">Status:</h6>
                    <span class=" font badge bg-light-success users-view-status">{{jobData?.status[0]?.displayname}}</span>
                    <span class="font primary" *ngIf="!jobData?.status[0]?.displayname">Data Not Found</span>
                  </div>
                  <!-- <div class="col-12 col-sm-2 p-3 d-flex align-itms-center firstdiv">
                    <h6 class="primary align-self-center mb-0 mx-1">Verified:</h6>
                    <span class="font primary">Yes</span>                  
                  </div> -->
                </div>
                <h5 class="mb-2 text-bold-500"><i class="ft-info mr-2"></i>
                  Job Info</h5>
                <div class="table-responsive">
                  <table class="table table-borderless">
                    <tbody>
                      <tr>
                        <td>Project Name:</td>
                        <td class="users-view-name">
                            <span>{{jobData?.name |titlecase}}</span>
                            <span *ngIf="!jobData?.name">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Project Alert:</td>
                        <td class="users-view-name">
                            <span class="badge badge-pill bg-light-success text-capitalize mr-1" [ngClass]="{'bg-light-danger':jobData?.isalert=='yes'}">{{jobData?.isalert |titlecase}}</span>
                            <span *ngIf="!jobData?.isalert">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Project Priority:</td>
                        <td class="users-view-name">
                            <span>{{jobData?.priority[0]?.displayname}}</span>
                            <span *ngIf="!jobData?.priority[0]?.displayname">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Skills:</td>
                        <td class="users-view-name">
                            <div  *ngFor="let item of jobData?.skills ; let i as index; last as isLast">
                              <span>{{item.displayname}}</span>
                            </div> 
                            <span *ngIf="!jobData?.skills">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Source:</td>
                        <td class="users-view-name">
                            <div  *ngFor="let item of jobData?.source ; let i as index; last as isLast">
                              <span>{{item?.displayname}}</span>
                            </div> 
                            <span *ngIf="!jobData?.source">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Channel:</td>
                        <td class="users-view-name">
                              <span *ngIf="jobData?.channel?.name">{{jobData?.channel?.name}}</span>
                            <span *ngIf="!jobData?.channel?.name">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Technology:</td>
                        <td class="users-view-name">
                            <div  *ngFor="let item of jobData?.technology; let i as index; last as isLast">
                              <span>{{item?.displayname}}</span>
                            </div> 
                            <span *ngIf="!jobData?.technology">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>References:</td>
                        <td class="users-view-name">
                            <span class="badge badge-pill text-capitalize bg-light-primary mr-1" *ngFor="let item of jobData?.references ; let i as index; last as isLast">
                              <a [href]="item.links" target="_blank">
                                {{item.name}}
                              </a>
                            </span> 
                            <span *ngIf="!jobData?.references">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Hunting By:</td>
                        <td class="users-view-name">
                            <div  *ngFor="let item of jobData?.hunting_by ; let i as index; last as isLast">
                              <span>
                                {{item?.name}}
                              </span>
                              <span *ngIf="item.length>1 && !isLast">,</span>
                            </div> 
                            <span *ngIf="!jobData?.hunting_by">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Farming By:</td>
                        <td class="users-view-name">
                            <div *ngFor="let item of jobData?.farming_by ; let i as index; last as isLast">
                              {{item?.name}}
                              <span *ngIf="item.length>1 && !isLast">,</span>
                            </div> 
                            <span *ngIf="!jobData?.farming_by">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Description:</td>
                        <td  [innerHTML]="jobData?.description | safeHtml"></td>
                        <td *ngIf="!jobData?.description">Data Not Found</td>
                      </tr> 
                      <tr>
                        <td>Alert Notes:</td>
                        <td  [innerHTML]="jobData?.alert_notes | safeHtml"></td>
                        <td *ngIf="!jobData?.alert_notes">Data Not Found</td>
                      </tr> 
                      <tr>
                        <td>Feature:</td>
                        <td  [innerHTML]="jobData?.feature | safeHtml"></td>
                        <td *ngIf="!jobData?.feature">Data Not Found</td>
                      </tr> 
                      
                      <tr>
                        <td>Notes:</td>
                        <td  [innerHTML]="jobData?.notes | safeHtml"></td>
                        <td *ngIf="!jobData?.notes">Data Not Found</td>
                      </tr>   
                      <tr>
                        <td>Admin Notes: </td>
                        <td  [innerHTML]="jobData?.admin_notes | safeHtml"></td>
                        <td *ngIf="!jobData?.admin_notes">Data Not Found</td>
                      </tr>                
                    </tbody>
                  </table>
                </div>
                 <h5 class="mb-2 text-bold-500"><i class="ft-info mr-2"></i>
                    Job Audit Info</h5>
                  <div class="table-responsive">
                    <table class="table table-borderless m-0">
                      <tbody>
                        <tr>
                          <td>Sprints:</td>
                          <td>
                            <span *ngIf="jobData?.sprints?.name">{{jobData?.sprints?.name}}</span>
                            <span *ngIf="!jobData?.sprints?.name">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>MOM:</td>
                          <td>
                            <span *ngIf="jobData?.mom?.name">{{jobData?.mom?.name}}</span>
                            <span *ngIf="!jobData?.mom?.name">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>BitBucket:</td>
                          <td>
                            <span *ngIf="jobData?.bitbucket?.name">{{jobData?.bitbucket?.name}}</span>
                            <span *ngIf="!jobData?.bitbucket?.name">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>KPI:</td>
                          <td>
                            <span *ngIf="jobData?.kpi?.name">{{jobData?.kpi?.name}}</span>
                            <span *ngIf="!jobData?.kpi?.name">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Communication:</td>
                          <td>
                            <span *ngIf="jobData?.Communication?.name">{{jobData?.Communication?.name}}</span>
                            <span *ngIf="!jobData?.Communication?.name">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Reports:</td>
                          <td>
                            <span *ngIf="jobData?.reports?.name">{{jobData?.reports?.name}}</span>
                            <span *ngIf="!jobData?.reports?.name">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Work Dairy:</td>
                          <td>
                            <span *ngIf="jobData?.workdairy?.name">{{jobData?.workdairy?.name}}</span>
                            <span *ngIf="!jobData?.workdairy?.name">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Demo:</td>
                          <td>
                            <span *ngIf="jobData?.demo?.name">{{jobData?.demo?.name}}</span>
                            <span *ngIf="!jobData?.demo?.name">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>FRS/DMS:</td>
                          <td>
                            <span *ngIf="jobData?.dmsfrs?.name">{{jobData?.dmsfrs?.name}}</span>
                            <span *ngIf="!jobData?.dmsfrs?.name">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>QA:</td>
                          <td>
                            <span *ngIf="jobData?.qa?.name">{{jobData?.qa?.name}}</span>
                            <span *ngIf="!jobData?.qa?.name">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>CRequest:</td>
                          <td>
                            <span *ngIf="jobData?.crequest?.name">{{jobData?.crequest?.name}}</span>
                            <span *ngIf="!jobData?.crequest?.name">Data Not Found</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <h5 class="mb-2 text-bold-500"><i class="ft-info mr-2"></i>
                    Lead Info</h5>
                    <div class="col-12">
                      <div class="table-responsive">
                        <table class="table table-borderless">
                          <tbody>
                            <tr>
                              <td>Lead Title:</td>
                              <td class="users-view-name">
                                  <span>{{jobData?.leads?.title }}</span>
                                  <span *ngIf="!jobData?.leads?.title">Data Not Found</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Lead Type:</td>
                              <td class="users-view-name">
                                  <span>{{jobData?.leads?.type?.displayname }}</span>
                                  <span *ngIf="!jobData?.leads?.type?.displayname">Data Not Found</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Source:</td>
                              <td class="users-view-name">
                                  <span>{{jobData?.leads?.source.displayname }}</span>
                                  <span *ngIf="!jobData?.leads?.source.displayname">Data Not Found</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Lead Stage:</td>
                              <td class="users-view-name">
                                  <span>{{jobData?.leads?.lead_stage?.displayname }}</span>
                                  <span *ngIf="!jobData?.leads?.lead_stage?.displayname">Data Not Found</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Lead Status:</td>
                              <td class="users-view-name">
                                  <span>{{jobData?.leads?.lead_status?.displayname }}</span>
                                  <span *ngIf="!jobData?.leads?.lead_status?.displayname">Data Not Found</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Next Action:</td>
                              <td class="users-view-name">
                                  <span>{{jobData?.leads?.next_action?.displayname }}</span>
                                  <span *ngIf="!jobData?.leads?.next_action?.displayname">Data Not Found</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Created By:</td>
                              <td class="users-view-name">
                                  <span>{{jobData?.leads?.created_by?.name }}</span>
                                  <span *ngIf="!jobData?.leads?.created_by?.name">Data Not Found</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Last Updated By:</td>
                              <td class="users-view-name">
                                  <span>{{jobData?.leads?.last_updatedby?.name }}</span>
                                  <span *ngIf="!jobData?.leads?.last_updatedby?.name">Data Not Found</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
              </div>
            </div>
          </div>
          <!-- User detail ends -->
        </div>
        <div class="col-12">
          <!-- Card data starts -->
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-xl-12 users-module">
                    <div class="table-responsive">
                      <table class="table mb-0">
                        <thead>
                          <tr>
                            <!-- <th>Total Fee</th> -->
                            
                            <th>Net Amount</th>
                            <th>Total Paid</th>
                            <th>Paid Amount</th>
                            <th>Pending Amount</th>
                            <th>Mode</th>
                            <th>Status</th>
                            <th>Due Date</th>
                            <th>Payment Date</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody *ngIf="payment_data">
                          <tr *ngFor="let payment of payment_data">
                                                    
                            <td>
                              <span>{{ payment.job_id.projectbudget |  currency:'USD':'symbol':'1.0-0' }}</span>
                            </td>
                            <td>
                              <span>{{ payment.TotalAmount |  currency:'USD':'symbol':'1.0-0' }}</span>
                            </td>
                            <td>
                              <span
                                class="badge bg-light-success"  placement="top"
                                ngbTooltip="{{payment?.payment_notes}}">{{ payment?.PaidAmount |  currency:'USD':'symbol':'1.0-0' }}</span>
                            </td>
                            <td>
                              <span
                                class="badge bg-light-danger">{{ payment?.TotalPendingAmount |  currency:'USD':'symbol':'1.0-0' }}</span>
                            </td>
                            <td>
                              <span>{{ payment?.mode[0]?.displayname }}</span>
                            </td>
                            <td>
                              <span *ngIf="payment?.payment_status =='due'" class="badge bg-light-primary">{{ payment?.payment_status }}</span>
                              <span *ngIf="payment?.payment_status =='received'" class="badge bg-light-success">{{ payment?.payment_status }}</span>
    
                            </td>
                            <td>
                              <span *ngIf="payment?.payment_status =='due'" [ngClass]="{'danger':payment?.payment_date}">{{ payment?.payment_date | date :'mediumDate' }}</span>
                              <span *ngIf="payment?.payment_status !=='due'" style="margin-left: 20px;">-</span>
                            </td>
                            <td>
                              <span *ngIf="payment?.payment_status =='received'">{{ payment?.payment_date | date :'mediumDate' }}</span>
                              <span *ngIf="payment?.payment_status =='due'">{{ payment?.payment_date | date :'mediumDate' }}</span>
                            </td>
                            <!-- <td>
                              <i class="ft-edit text-primary cursor-pointer mr-2" (click)="openAddModal(myModalPayment,'update',payment)"></i>
                              <i *ngIf="user_role.roles =='admin' || user_role.roles =='employee'" class="ft-trash-2 text-danger cursor-pointer" (click)="confirmDelete(payment?._id)"></i>
                            </td> -->
                          </tr>
                        </tbody>
                        <tbody *ngIf="payment_data?.length<1">
                          <p  style="color:red">Data Not Found</p>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Card data ends -->
        </div>
      </div>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
    </div>
    </div>
  </ng-template>
</div>